import React from "react";
import Sidebar from "../components/Sidebar";

class Introduction extends React.Component {
  render() {
    return (
      <div className="intro">
        <div className="container">
          <div className="row">
            {/* Main content - 9 columns */}
            <div className="col-lg-9">
              <div className="section_title_container text-center">
                <div className="section_title">
                  <h1>CAAIE 2026</h1>
                </div>
              </div>
              <div className="intro_left_content text_left">
                <p align="left">
                  The 6th Conference on Advanced Artificial Intelligence and
                  Education (CAAIE 2026) will be held in Cardiff, United Kingdom
                  on 5 - 7 Aug 2026. <br></br>The conference is an annual event
                  and recognized as one of the major series of conferences in
                  Artificial Intellgence and Education Technologies. CAAIE
                  continues to retain its tradition of being a high quality
                  conference. The event will open an opportunity for academics
                  and industry professionals worldwide to exchange their
                  knowledge of the state-of-the-art research and development in
                  information technology and applications. It will help
                  participants establish new links and extend professional
                  networks. This conference addresses the importance that IT
                  professionals stretch across narrowly defined subject areas
                  and constantly acquire a global technical and social
                  perspective. CAAIE 2026 offers such an opportunity to
                  facilitate cross-disciplinary and social gatherings.{" "}
                </p>{" "}
                <div className="col-lg-12 schedule_col">
                  <div className="schedule_container">
                    {/* <div className="schedule_title_bar schedule_title_bar_1 text-center">
                      Proceedings Publication
                    </div> */}
                    <div className="schedule_content text-left">
                      <strong>
                        {" "}
                        All accepted papers will be published as book chapters
                        in a High Quality book by Springer Book{" "}
                        <a
                          href="https://link.springer.com/series/17396"
                          target="_blank"
                        >
                          {" "}
                          "Informtion Systems Engineering and Management "
                        </a>{" "}
                        in both hardcopy as well as electronic version in ISSN
                        (Print): 3004-958X and ISSN (electronic):3004-9598
                        <a
                          href="https://link.springer.com/series/17396"
                          target="_blank"
                        >
                          {" "}
                          <img src={require("../assets/springerlink.jpg")} />
                        </a>
                      </strong>
                    </div>
                  </div>
                </div>
                <p></p>
                <p align="left">
                  The use of Artificial Intelligence (AI) in modern education is
                  rapidly expanding and transforming how teaching and learning
                  are designed, delivered, and evaluated. This track explores
                  the opportunities AI presents for advancing educational
                  pedagogy, enhancing learning technologies, and enabling smart
                  education systems.<br></br> Since{" "}
                  <a href="https://www.icita.world/aaie/2021>">2021</a>, CAAIE
                  has been running as a special track within ICITA and has
                  consistently maintained a high conference standard. Over the
                  years, several thousand academics and IT professionals have
                  used it as a platform for presenting, publishing, and
                  networking around their research. We are confident that even
                  more will be achieved in the coming decade. <br></br>
                  <br></br>The use of Artificial Intelligence (AI) in modern
                  education is rapidly expanding and transforming how teaching
                  and learning are designed, delivered, and evaluated. Due to
                  significant interest in educational technologies and the rapid
                  rise of AI applications, we are now establishing this special
                  track as a standalone conference. This conference explores the
                  opportunities AI presents for advancing educational pedagogy,
                  enhancing learning technologies, and enabling smart education
                  systems.The event will be held in Cardiff, United Kingdom,
                  from 5–7 August 2026. <br></br>
                  <br></br>The aim of CAAIE is to provide a platform for
                  academics, researchers, and engineers in computer and
                  educational technology to meet, exchange ideas, and build
                  professional networks. It is a forum that promotes both
                  discipline-specific research and multidisciplinary
                  collaboration. The uniqueness of CAAIE lies in its ability to
                  bring together scientists and practitioners worldwide to
                  discuss not only technical advancements but also the broader
                  applications and societal impacts of technology.
                </p>
                <p align="left">
                  Full and short papers accepted and registered will be
                  published in a Springer Book &nbsp;
                  <a
                    href="https://link.springer.com/series/17396"
                    target="_blank"
                  >
                    Informtion Systems Engineering and Management
                  </a>
                  , submitted for indexation by Web of Sciences, Google Scholar
                  , among others, and will be available in the SpringerLink
                  Digital Library.
                </p>
                <div className="row">
                  <div className="col-lg-4">
                    {" "}
                    <a
                      href="https://link.springer.com/series/17396"
                      target="_blank"
                    >
                      <img
                        src={require("../assets/springerlink.jpg")}
                        width="230"
                        height="auto"
                      />{" "}
                    </a>
                  </div>
                  <div className="col-lg-4">
                    <img
                      src={require("../assets/web.png")}
                      width="230"
                      height="auto"
                    />
                  </div>
                  <div className="col-lg-4">
                    <img
                      src={require("../assets/scholar.png")}
                      width="230"
                      height="auto"
                    />
                  </div>
                </div>
                <br></br>
                <br></br>
                <p></p>
              </div>
            </div>

            {/* Sidebar - 3 columns */}
            <Sidebar />
          </div>
        </div>
      </div>
    );
  }
}
export default Introduction;
